import {Component, Injector} from '@angular/core';
import {BaseAdminPanelComponent} from "../../base-admin-panel/base-admin-panel.component";
import {Observable} from "rxjs";
import {ShiftViewModel} from "../Models/ShiftViewModel";
import {EditShiftComponent} from "../edit-shift.component";
import {ShiftsService} from "../../../../services/shifts.service";
import {CreateShiftComponent} from "../create-shift.component";


@Component({
    selector: '[app-shifts]',
    templateUrl: './shifts.component.html',
    styleUrls: ['./shifts.component.css'],
    standalone: false
})
export class ShiftsComponent extends BaseAdminPanelComponent{
  private shiftsService: ShiftsService;

  constructor(protected injector: Injector) {
    super(injector);
    this.shiftsService = injector.get(ShiftsService);
    this.entityName = "Shift";
  }

  protected Refresh() {
    this.shiftsService.GetShifts()
      .subscribe(drivers => {
      this.objects = drivers;
    });
  }


  protected doDeleteObject(id: number): Observable<any> {
    return this.shiftsService.DeleteShift(id);
  }

  public openCreateModal() {
    this.prepareModal(CreateShiftComponent);
    this.componentRef.instance.open(new ShiftViewModel());
  }

  public openEditModal(shift: ShiftViewModel) {
    this.prepareModal(EditShiftComponent);
    this.componentRef.instance.open(shift);
  }
}
